import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RewardsWalletQuery, RewardsWalletService, ScreenType, WalletGroupItem } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { ProductCode } from './../../shared/utilities/product-code';

import gsap from 'gsap';
import Draggable from 'gsap/Draggable';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit, AfterViewInit, OnDestroy {
  walletItems$: Observable<WalletGroupItem[]>;
  productCode = ProductCode;
  screenType = ScreenType;

  @ViewChild('walletContainer', { static: false }) walletContainerRef: ElementRef;
  private draggableInstance: any;

  constructor(
    private rewardsWalletQuery: RewardsWalletQuery,
    private rewardsWalletService: RewardsWalletService
  ) {
    gsap.registerPlugin(Draggable);
  }

  async ngOnInit() {
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItems$ = this.rewardsWalletQuery.selectGroupedUnredeemedWalletItems();
  }

  ngAfterViewInit() {
    if (this.walletContainerRef) {
      this.initiateDraggable(355);
    }
  }

  initiateDraggable(height: number) {
    const walletContainerElement = this.walletContainerRef.nativeElement.closest('fgb-wallet-page') as HTMLElement;
    const walletContainerHeight = walletContainerElement.clientHeight;
    let barcodeHeight = height;
    this.draggableInstance = Draggable.create(this.walletContainerRef.nativeElement, {
      type: 'y',
      edgeResistance: 1,
      bounds: { minY: -barcodeHeight, maxY: 0 },
      inertia: true,
      handle: '.grab-point',
      onDrag: () => {
        const y = this.draggableInstance.y;
        walletContainerElement.style.height = `${walletContainerHeight + barcodeHeight + y}px`;
      },
      onDragEnd: () => {
        const y = this.draggableInstance.y;
        let snapY = 0;
        // Snap to nearest
        snapY = Math.abs(y + barcodeHeight) < Math.abs(y) ? -barcodeHeight : 0;
        gsap.to(this.walletContainerRef.nativeElement, {
          y: snapY,
          duration: 0.3,
          onUpdate: () => {
            const currentY = gsap.getProperty(this.walletContainerRef.nativeElement, 'y') as number;
            walletContainerElement.style.height = `${walletContainerHeight + barcodeHeight + currentY}px`;
          },
        });
      },
    })[0];
  }
  ngOnDestroy() {
    if (this.draggableInstance) {
      this.draggableInstance.kill();
    }
  }
}
